module.exports = __webpack_public_path__ + "img/icon_arrow_left.e43ef3c7.svg";